<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
  }

  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: rgb(255, 255, 255);
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    /*-webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255,0.8);*/
    border-radius: 3px;
    background-color: rgba(199, 201, 204, .15);
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 6px rgba(199, 201, 204, .3);
    transition: background-color .3s;
    background-color: rgba(199, 201, 204, .3);
  }

  /*滑块获得焦点*/
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgb(199, 201, 204);
  }

  /* 弹框内form表单限制高度，超出显示滚动条*/
  .dialog_scroll {
    max-height: calc(100vw / 750 * 200);
    overflow: auto;
  }

  /* 设置dialog内滚动条轨道背景色为白色*/
  .dialog_scroll::-webkit-scrollbar-track {
    background-color: rgb(255, 255, 255);
  }

  #app .el-form--inline{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue